import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { AdminAppSidebar } from '@/components/molecules/admin-app-sidebar';
import { AdminNavHeader } from '@/components/molecules/admin-nav-header';
import { useAdminAuth } from '../hooks';
import { routes } from '../routing';
import { Loader } from '../components';

export const AdminAuthLayout: React.FC = () => {
  const { isAuthenticated, loading } = useAdminAuth();

  if (loading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.adminLogin} replace />;
  }

  return (
    <div className="flex w-full min-h-screen bg-light-gray">
      <SidebarProvider>
        <AdminAppSidebar />
        <SidebarInset>
          <main className="flex flex-col min-h-screen bg-primary-bg-default">
            <AdminNavHeader />
            <div className="pb-6">
              <Outlet />
            </div>
          </main>
        </SidebarInset>
      </SidebarProvider>
    </div>
  );
};
